import { Injectable } from "@angular/core";
import { environmentPingId ,pingIdToken, environment} from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { VehicleData } from "./api-interfaces/vehicleData.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class VehicleDataService {
    ApiURL: string = "";
    ApiURLp: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL = environmentPingId.PingIdvehicleDataUrl + 'vehicles/info';
        this.ApiURLp = environment.vehicleDataUrl + 'VehicleData/';
    }
    
    public getValidatedData(plate: string|null, customerIdentification?:string|null): Observable<any>{
       const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
            .set('x-apikey', pingIdToken.clientId);
                const requestOptions = {
                    headers: headers,
                };

        

        const countryId = this.helperService.user.countryId ? this.helperService.user.countryId : this.helperService.countryIdWebView;
        const body: any = {
                Plate: plate,
                CountryId: Number(countryId),
                Identification :customerIdentification ?? ""
                };
       


   
        return this.http.post(this.ApiURL,body,requestOptions);
    }

     public getValidatedDataWithCountryAndbrand(plate: string|null, brand:any,customerIdentification?:string|null,): Observable<any>{
       const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
            .set('x-apikey', pingIdToken.clientId);
                const requestOptions = {
                    headers: headers,
                };

        

        const countryId = this.helperService.user.countryId ? this.helperService.user.countryId : this.helperService.countryIdWebView;
        const body: any = {
                plate: plate,
                countryId: Number(countryId),
                identification :customerIdentification ?? "",
                idBrand:brand
                };
       
     let url = this.ApiURLp+"GetPreloadDataVehicle"
        return this.http.post(this.ApiURL,body,requestOptions);
    }








    public getVEhicleDataByPlate(plate:string): Observable<VehicleData>{
        const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
            .set('x-apikey', pingIdToken.clientId );
        const requestOptions = {
            headers: headers,
        };
         const body: any = {
                Plate: plate,
                };
       
        return this.http.post<VehicleData >(this.ApiURL,body,requestOptions) 
    }

}
